// components/Footer.js
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/pricing", label: "Pricing" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <footer className="border-t border-white/10 bg-black py-14 text-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-end">
          <div className="text-center md:text-left">
            <Link
              to="/"
              className="inline-block max-w-3xl text-[clamp(2.4rem,6vw,5.6rem)] font-normal leading-[0.88] tracking-[-0.07em] transition-colors hover:text-[#d7d1c4]"
            >
              William Sisulu{" "}
              <span className="editorial-italic">Odhiambo</span>
            </Link>

            <p className="mt-5 text-sm font-semibold uppercase tracking-[0.2em] text-[#b9b4aa]">
              A lover of good code.
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://www.linkedin.com/in/william-odhiambo-481689265/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-gray-300 transition-colors hover:border-[var(--brand-blue)] hover:text-[var(--brand-blue)]"
              aria-label="LinkedIn"
            >
              <i className="bx bxl-linkedin text-2xl"></i>
            </a>

            <a
              href="https://github.com/i-william17"
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-gray-300 transition-colors hover:border-[var(--brand-green)] hover:text-[var(--brand-green)]"
              aria-label="GitHub"
            >
              <i className="bx bxl-github text-2xl"></i>
            </a>

            <a
              href="mailto:info@williamwritescode.com"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-gray-300 transition-colors hover:border-[var(--brand-blue)] hover:text-[var(--brand-blue)]"
              aria-label="Email"
            >
              <i className="bx bx-envelope text-2xl"></i>
            </a>

            <a
              href="https://wa.me/254711160437?text=Hi%20William%2C%20I'm%20interested%20in%20your%20services!"
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-gray-300 transition-colors hover:border-[var(--brand-green)] hover:text-[var(--brand-green)]"
              aria-label="WhatsApp"
            >
              <i className="bx bxl-whatsapp text-2xl"></i>
            </a>

            <a
              href="https://x.com/talesofwilliam"
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-gray-300 transition-colors hover:border-[var(--brand-blue-2)] hover:text-[var(--brand-blue-2)]"
              aria-label="X/Twitter"
            >
              <i className="bx bxl-twitter text-2xl"></i>
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-6 border-t border-white/10 pt-8 md:flex-row">
          <p className="text-center text-sm text-gray-400 md:text-left">
            © {currentYear} William Sisulu Odhiambo. All rights reserved.
          </p>

          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3">
            {footerLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-400 transition-colors hover:text-white"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-8 border-t border-white/10 pt-6 text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gray-500">
            Designed by{" "}
            <Link
              to="/"
              className="text-white transition-colors hover:text-[var(--brand-green)]"
            >
              William Writes Code
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
